import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const TRANSLATIONS = {
  once: I18n.t('react.request.frequency.option_once'),
  few_times: I18n.t('react.request.frequency.option_few_times'),
  regular: I18n.t('react.request.frequency.option_regular'),
  not_sure: I18n.t('react.request.frequency.option_not_sure')
}

const Frequency = () => {
  const { nextPage, setFrequency } = useActions(sceneLogic)
  const { frequency } = useValues(sceneLogic)

  const updateFrequencyAndProceed = frequency => {
    setFrequency(frequency)
    nextPage()
  }

  return (
    <div className='list-choice'>
      <h1>{I18n.t('react.request.frequency.title')}</h1>
      <ul className='clickable-list'>
        {Object.keys(TRANSLATIONS).map(key => (
          <li
            key={key}
            onClick={() => updateFrequencyAndProceed(key)}
            className={frequency === key ? 'selected' : null}
          >
            {TRANSLATIONS[key]}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Frequency
